module.exports = __webpack_public_path__ + "static/media/online_tuition_huion_tablet2.83088eb6.jpg";